/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Consistency_NoneInputs */

const en_us2_progress_report_consistency_none = /** @type {(inputs: Progress_Report_Consistency_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`No workouts this week.`);
	return /** @type {LocalizedString} */ (`No workouts this month.`)
	
};

const pt_br2_progress_report_consistency_none = /** @type {(inputs: Progress_Report_Consistency_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nenhum treino nesta semana.`);
	return /** @type {LocalizedString} */ (`Nenhum treino neste mês.`)
	
};

const es_419_progress_report_consistency_none = /** @type {(inputs: Progress_Report_Consistency_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Ningún entrenamiento esta semana.`);
	return /** @type {LocalizedString} */ (`Ningún entrenamiento este mes.`)
	
};

const pt_pt2_progress_report_consistency_none = /** @type {(inputs: Progress_Report_Consistency_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nenhum treino nesta semana.`);
	return /** @type {LocalizedString} */ (`Nenhum treino neste mês.`)
	
};

const fr_fr2_progress_report_consistency_none = /** @type {(inputs: Progress_Report_Consistency_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Aucune séance cette semaine.`);
	return /** @type {LocalizedString} */ (`Aucune séance ce mois-ci.`)
	
};

const de_de2_progress_report_consistency_none = /** @type {(inputs: Progress_Report_Consistency_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Keine Trainings diese Woche.`);
	return /** @type {LocalizedString} */ (`Keine Trainings diesen Monat.`)
	
};

const it_it2_progress_report_consistency_none = /** @type {(inputs: Progress_Report_Consistency_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nessun allenamento questa settimana.`);
	return /** @type {LocalizedString} */ (`Nessun allenamento questo mese.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "No workouts this week." |
* | * | "No workouts this month." |
*
* @param {Progress_Report_Consistency_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_consistency_none = /** @type {((inputs: Progress_Report_Consistency_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Consistency_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_consistency_none(inputs)
	if (locale === "es-419") return es_419_progress_report_consistency_none(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_consistency_none(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_consistency_none(inputs)
	if (locale === "de-DE") return de_de2_progress_report_consistency_none(inputs)
	if (locale === "it-IT") return it_it2_progress_report_consistency_none(inputs)
	return en_us2_progress_report_consistency_none(inputs)
});
export { progress_report_consistency_none as "progress-report.consistency_none" }